import { getBlogIndexData } from 'api/api';

export const fetchSearchData = async (
    paramDict,
    onSuccess,
    onError,
    onLoading
) => {
    if (onLoading !== undefined) {
        onLoading(true);
    }

    try {
        const result = await getBlogIndexData(paramDict);

        if (result === undefined || result.results === undefined) {
            if (onError) {
                onError('No results found');
            }
            return;
        }

        if (onSuccess !== undefined) {
            onSuccess(result);
        }
    } catch (error) {
        if (onError !== undefined) {
            onError(error.message);
        }
    } finally {
        if (onLoading !== undefined) {
            onLoading(false);
        }
    }
};

export const fetchPaginatedNoteListData = async (
    paramDict,
    nextPage,
    onSuccess,
    onError,
    onLoading
) => {
    if (onLoading !== undefined) {
        onLoading(true);
    }

    try {
        const result = await getBlogIndexData(paramDict);

        if (result === undefined || result.results === undefined) {
            if (onError) {
                onError('No results found');
            }
            return;
        }

        if (onSuccess !== undefined) {
            onSuccess(result, nextPage);
        }
    } catch (error) {
        if (onError !== undefined) {
            onError(error.message);
        }
    } finally {
        if (onLoading !== undefined) {
            onLoading(false);
        }
    }
};
